module.exports = __webpack_public_path__ + "static/media/Macedonia.010e1e0e.png";